import {Button, Typography} from '@mui/material';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {Container} from './styles';
import {HeaderSectionProps} from './types';

const {change} = translations['pt-br'].commons;

const HeaderSection = ({title, handleClick, dataTagId}: HeaderSectionProps) => (
	<Container>
		<Typography variant="subtitle2" color="text.secondary">
			{title}
		</Typography>
		{handleClick ? (
			<Button onClick={handleClick} data-tag-id={dataTagId} variant="text">
				{change}
			</Button>
		) : null}
	</Container>
);

export {HeaderSection};
